export enum SourceType {
  UNSPECIFIED = 'Unspecified',
  PROVIDER_FACILITY_RETRIEVAL = 'Provider Facility Retrieval',
  MEDICATIONS_DIGITAL_DATA = 'Medications Digital Data',
  HIE_DATA = 'HIE Data',
}

const ORIGINAL_RECORD_SOURCE_TYPE_LABELS: Record<SourceType, string> = {
  [SourceType.UNSPECIFIED]: SourceType.UNSPECIFIED,
  [SourceType.PROVIDER_FACILITY_RETRIEVAL]: 'Provider/Facility Retrieval',
  [SourceType.MEDICATIONS_DIGITAL_DATA]: 'Medications Digital Data',
  [SourceType.HIE_DATA]: 'HIE Data',
};

export const getOriginalRecordSourceTypeLabel = (
  sourceType: SourceType,
): string => ORIGINAL_RECORD_SOURCE_TYPE_LABELS[sourceType];

const ORIGINAL_RECORD_SOURCE_TYPES_WITH_DOWNLOAD_TRACKING = new Set<SourceType>(
  [SourceType.HIE_DATA, SourceType.PROVIDER_FACILITY_RETRIEVAL],
);

export const canTrackOriginalRecordDownload = (
  sourceType: SourceType,
): boolean =>
  ORIGINAL_RECORD_SOURCE_TYPES_WITH_DOWNLOAD_TRACKING.has(sourceType);
